module.exports = __webpack_public_path__ + "static/media/banner3.bf432e55.jpg";